import classNames from 'classnames';
import { Tabs, FlexContainer } from 'components';
import { useState } from 'react';
import styles from './ViewPayments.module.scss';

const tabOptions = [
  { key: 'details', value: 'Details' },
  { key: 'payments', value: 'Payments' },
];

/**
 * ViewPayments
 *
 * @return {JSX.Element}
 */
const ViewPayments = ({ className, header, details, payments }) => {
  const [activeTab, setActiveTab] = useState(tabOptions[0].key);
  const handleTabChange = (v) => setActiveTab(v);

  return (
    <FlexContainer
      className={classNames(
        styles.ViewPayments,
        className,
        ViewPayments.displayName
      )}
      column
    >
      <FlexContainer className={styles.Header} column>
        {header}
      </FlexContainer>
      <FlexContainer column>
        <Tabs
          options={tabOptions}
          onChange={handleTabChange}
          value={activeTab}
        />
        <FlexContainer className={styles.Body} column>
          {activeTab === 'payments' ? payments : details}
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

ViewPayments.displayName = 'ViewPayments';

export default ViewPayments;
